import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import LinkAccountLogin from './Component';
import actions from './actions';
import selectors from './selectors';
import startupConfigSelectors from '../../components/StartupConfig/selectors';
import getInitialDataSelectors from '../../components/GetDetailsFromRoute/selectors';

const mapStateToProps: any = createSelector(
  selectors.selectStep,
  selectors.selectMobileNumber,
  getInitialDataSelectors.selectContext,
  startupConfigSelectors.selectConfiguration,
  (step, mobileNumber, context, configuration) => ({
    step: step ? step : 0,
    mobileNumber,
    context,
    configuration,
  })
);

const mapDispatchToProps: any = (dispatch: any) => bindActionCreators(actions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LinkAccountLogin);
